import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PamDialogComponent } from './pam-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class PamDialogService {
  private readonly dialogService = inject(MatDialog);
  private dialogRef: MatDialogRef<PamDialogComponent> = null;

  public openDialog(
    partnerId?: string,
    accountGroupId?: string,
    defaultReason?: string,
    disableClose?: boolean,
    entitlementId?: string,
  ): MatDialogRef<PamDialogComponent> {
    if (this.dialogRef) {
      return this.dialogRef;
    }

    this.dialogRef = this.dialogService.open(PamDialogComponent, {
      width: '600px',
      maxWidth: '100vw',
      maxHeight: '100dvh',
      disableClose: disableClose ?? true,
      data: {
        partnerId,
        accountGroupId,
        defaultReason,
        entitlementId,
      },
    });
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });

    return this.dialogRef;
  }
}
